/*globals jQuery, bootbox, Settings, PIE, notes, ga*/

window.isObject = function (o) {
  return o === Object(o);
};

$(window).on('load', function () {
  //Mainly for UBS to handle their network slowness and slow loading js (where href set by javascript) - Soc Sec
  $('.prevent-click-before-load').removeClass('prevent-click-before-load');

  //used in script template for Expectations so moved to window onload instead of document ready
  $('.tooltip-alt').tooltip({
    trigger: 'hover',
    html: true
  });
});

$(window).on('resize', function () {
  //For RWD purposes (window resizing or device orientation changes)
  var stickFooterId = 'sticky-footer-' + this.id;

  clearTimeout(stickFooterId);
  stickFooterId = setTimeout(Mgp.SetFooter(), 250);
});

var Mgp = (function ($) {
  'use strict';

  var cancelAnimationEvents = 'scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove';
  var modalOpen = false;
  var $focusedElem = null;

  $(document).ready(function () {
    var oldSSB, oldRSB;

    Mgp.SetupTheme();
    Mgp.Navigate.GetLabVideoConfigOptions();
    Mgp.DisableInputs();
    Mgp.MaskInputs();
    Mgp.SetFooter();
    Mgp.SignOff();
    Mgp.SetDataAttributeForE2ETesting(false);
    Mgp.TogglePassword.Init();

    //prevent form submit when form has multiple submit buttons and enter key pressed
    //(i.e. Stock Option Exercise Scenarios page)
    //allow-enter class on a submit button will override this (used on the Enter Holdings page)
    $('form').on('keypress', function (e) {
      var elemsSubmit = $('input[type=submit]');
      if (elemsSubmit.length > 1) {
        if (!elemsSubmit.hasClass('allow-enter')) {
          var code = (e.keyCode ? e.keyCode : e.which);
          if (code === 13)
            return false;
        }
      }
    });

    $(document).on('click', '.use-loading-indicator', function () {
      Mgp.Navigate.Loading($(this));
    });

    $(document).on('click', 'input[type=submit], button[type=submit], a.delete-item, a.prevent-double-click, input[type=button].prevent-double-click, button.prevent-double-click', function (event) {
      Mgp.PreventDoubleClick($(this), event);
    });

    $(document).on('focus change', 'input[type=text]', function () {
      this.previousvalue = this.value;
    });

    $(document).on('click', '.btn-cancel', function () {
      var $self = $(this),
        $form = $self.closest('form'),
        isPopup = $self.data('is-popup'),
        returnUrl = $self.attr('href'),
        validateFunc = $self.data('validate-function'),
        suppressWarnUser = $self.data('suppress-warn-user') === 'True'
          || $self.data('suppress-warn-user') ? true : false;

      //Used in rare cases we need to validate before cancel redirects or submits,
      //i.e. Investment Assets Margin Balance
      if (validateFunc) {
        if (!Mgp.CreateNamespacedFunction(validateFunc)()) {
          return false;
        }
      }

      if (!Settings.ViewOnly && !suppressWarnUser) {
        bootbox.confirm({
          message: 'Are you sure you want to lose your changes?',
          onEscape: true,
          buttons: {
            'cancel': {
              label: 'No',
              className: 'btn-cancel'
            },
            'confirm': {
              label: 'Yes',
              className: 'btn-done'
            }
          },
          callback: function (isConfirmed) {
            if (isConfirmed) {
              Mgp.Navigate.CancelBtnAction($self, $form, isPopup, returnUrl);
            }
          }
        });
        return false;
      }
      else {
        Mgp.Navigate.CancelBtnAction($self, $form, isPopup, returnUrl);
      }
    });

    $(document).on('change', '.format-amount', function () {
      var $field = $(this),
        decimalsattr = $field.attr('data-val-decimals') !== null ? $field.attr('data-val-decimals') : 0;

      $field.val(window.formatAmount($field.val(), decimalsattr));
    });

    $(document).on('change', '.format-rate', function () {
      var $field = $(this),
        decimalsattr = $field.attr('data-val-decimals') !== null ? $field.attr('data-val-decimals') : 2;

      $field.val(window.formatAmount($field.val(), decimalsattr));
    });

    $(document).on('change', '.format-age-years, .format-age-months', function () {
      var $field = $(this);

      $field.val(window.formatAmount($field.val(), 0));
    });

    $(document).on('focusout', 'input[type=text]', function () {
      if (this.previousvalue !== this.value) {
        $(this).trigger('change');
      }
    });

    $(window).on('scroll', function () {
      Mgp.ScrollToTop();
    });

    $('.scrollToTop').on('click', function () {
      $('html, body').animate(
        { scrollTop: 0 },
        600
      );

      Mgp.ScrollToTopMinPx = 600;
      $($('#skip-to-main-content-link').attr('href')).focus(); // reset focus at top for ADA

      return false;
    });

    $('#skip-to-main-content-link').on('click', function () {
      $($('#skip-to-main-content-link').attr('href')).focus();

      return false;
    });

    //// Global Fix for iOS Virtual Keyboard causing fixed position nav to jump on input fields
    //// This only triggers on touch devices
    //if (Modernizr.touch) {
    //  $(document).on('focus', 'textarea,input,select', function () {
    //    $('.navbar.navbar-fixed-top').css('position', 'absolute');
    //  }).on('blur', 'textarea,input,select', function () {
    //    $('.navbar.navbar-fixed-top').css('position', '');
    //  });
    //}

    $(document).on('click', 'a.toggle', function () {
      var $self = $(this),
        text = $self.text();

      //if has data-toggle uses Bootstrap to hide/show and for aria-expanded tag
      if (typeof $self.data('toggle') !== 'undefined') {
        if ($self.hasClass('moreless')) {
          if (text.indexOf('More') > -1) {
            $self.text(text.replace('More', 'Less'));
          }
          else if (text.indexOf('more') > -1) {
            $self.text(text.replace('more', 'less'));
          }
          else if (text.indexOf('Less') > -1) {
            $self.text(text.replace('Less', 'More'));
          }
          else if (text.indexOf('less') > -1) {
            $self.text(text.replace('less', 'more'));
          }
        }
      } else {
        if (typeof $self.attr('aria-expanded') !== 'undefined') {
          $self.attr('aria-expanded') === 'true' ?
            $self.attr('aria-expanded', 'false') : $self.attr('aria-expanded', 'true');
        }
      }
    });

    // Smooth Scrolling for "Jump-to" page links - only works when adding class "page-scroll" on anchor
    //tag so it doesn't conflict with other plugins (i.e.- Bootstrap tabs, accordions, etc.)
    Mgp.PageScroll();

    //Setup Modals
    Mgp.RenderModal();

    //Tables with Fixed Header - jquery_floatThead.js sticky header
    Mgp.Tables.FixedHeader();

    // Initialize Tab Drop
    if (typeof ($.fn.tabdrop) === 'function') {
      $('.nav-pills, .nav-tabs').tabdrop();
    }


    // Initialize Bootstrap Tooltip - done this way to handle dynamic elements - added keypress event for web accessibility
    $(document).on('keypress click', '.help-tooltip, .warning-tooltip, .slider-tooltip, .locked-tooltip', function (event) {
      var $self = $(this);

      $self.tooltip({
        trigger: 'click',
        container: 'body',
        html: true
      }).on('shown.bs.tooltip', function () {
        $('.tooltip-close').remove();
        Mgp.ToolTip.CreateCloseIcon();
      }).on('hide.bs.tooltip', function () {
        $('.tooltip-close').remove();
      });

      event.preventDefault();
    });

    //Modified from https://stackoverflow.com/a/33953365
    $(document).on('keypress click', function (e) {
      var $tooltip,
        $target = $(e.target),
        isTooltipClose = $target.hasClass('tooltip-close');

      //do nothing if there was a click on tooltip content unless on the close icon
      if (!isTooltipClose) {
        if ($target.hasClass('tooltip') || $target.closest('.tooltip').length) {
          return;
        }
      } else if (isTooltipClose) {
        e.preventDefault();
      }

      $('[data-toggle="tooltip"], .help-tooltip, .warning-tooltip, .slider-tooltip, .locked-tooltip').each(function () {
        $tooltip = $(this);

        if ((!$tooltip.is(e.target) &&
          $tooltip.has(e.target).length === 0 &&
          $('.tooltip').has(e.target).length === 0)
          || $target.hasClass('tooltip-close')) {
          $tooltip.tooltip('hide');
        } else {
          $tooltip.tooltip('toggle');
          Mgp.ToolTip.CreateCloseIcon();
        }
      });
    });

    // Initialize Bootstrap Popover ON HOVER- done this way to handle dynamic elements
    $(document).popover({
      selector: '.popover-hover',
      trigger: 'hover',
      placement: 'top',
      container: 'body',
      animation: true,
      html: true
    });

    $('[data-toggle="offcanvasMenu"]').on('click', function () {
      $('.offcanvas-left').toggleClass('active-menu-item');
    });

    // Trigger the collapse of dropdown main nav on mobile when touching Calculator (off-canvas menu) link
    $('.navbar-nav li.trigger-collapse a').on('click', function () {
      $('.navbar-collapse').collapse('hide');
    });

    // Hide Toolbar section if no items for it
    $('.toolbar-dropdown-container').each(function () {
      var $self = $(this);

      if ($self.find('li').length) {
        //hidden by default so items do not flicker on DOM load
        $self.show();
      }
    });

    Mgp.Toolbar.NavBarToggleDisplay();

    //$('.notes-link:not(.bound)').addClass('bound').on('click', function () {
    //  Mgp.Toolbar.Notes($(this));
    //  return false;
    //});

    $(document).on('click', 'a.popup, a.popup-video', function () {
      var self = $(this),
        url = self.attr('href'),
        width = self.attr('data-popup-width') || 992,
        height = self.attr('data-popup-height') || 620,
        dataPopupName = self.attr('data-popup-name'),
        //kluge for popups on popups in ie,
        //null window name or window name with spaces does not always create new window.
        name = dataPopupName ? dataPopupName.replace(/ /g, '') : ('_window' + Math.floor(Math.random() * 10001)),
        settings = self.attr('data-popup-settings');

      Mgp.PopupWindowHandle = null;

      if (settings) {
        if (settings.toLowerCase().indexOf('width') === -1) {
          settings += ',width=' + width;
        }
        if (settings.toLowerCase().indexOf('height') === -1) {
          settings += ',height=' + height;
        }
      }
      else {
        settings = 'resizable=yes,scrollbars=yes,status=no,width=' + width + ',height=' + height;
      }

      if (Settings.HasPartitionedCookies === 'true') {
        window.location.href = url;
      } else {
        Mgp.PopupWindowHandle = window.open(url, name, settings);
      }

      return false;
    });

    // Bootstrap Modal Shifting Body Content Fix for Bootstrap v3.3.2
    // GitHub #14040  https://github.com/twbs/bootstrap/issues/14040
    var fixedCls = '.navbar-fixed-top,.navbar-fixed-bottom';
    oldSSB = $.fn.modal.Constructor.prototype.setScrollbar;
    $.fn.modal.Constructor.prototype.setScrollbar = function () {
      oldSSB.apply(this);
      if (this.bodyIsOverflowing && this.scrollbarWidth)
        $(fixedCls).css('padding-right', this.scrollbarWidth);
    };

    oldRSB = $.fn.modal.Constructor.prototype.resetScrollbar;
    $.fn.modal.Constructor.prototype.resetScrollbar = function () {
      oldRSB.apply(this);
      $(fixedCls).css('padding-right', '');
    };

    //Prevent modal caching
    $(document).on('hidden.bs.modal', '.modal', function () {
      $(this).removeData('bs.modal');
      //reset element focus to the element that had focus before modal opened for web accessibility
      $focusedElem.trigger('focus');
    });

    //Prevent multiple modals from being open at the same time
    $(document).on('hide.bs.modal', '.modal', function () {
      modalOpen = false;
    });

    $(document).on('show.bs.modal', '.modal', function () {
      //get focused element on modal open so we can reset it to this element when the modal is
      //closed for web accessibility
      $focusedElem = $(':focus');

      if (modalOpen) {
        return false;
      }
      modalOpen = true;
    });

    //For web accessibility
    $(document).on('shown.bs.modal', '.modal', function () {
      var $self = $(this),
        $modalTitleElem = $self.find('.modal-title'),
        $helpTitleElem = $self.find('.modal-help-title'),
        role = $self.is('.bootbox-alert') ? 'alertdialog' : 'dialog';

      if ($modalTitleElem.length) {
        $modalTitleElem.attr('id', 'modal-help-title');
      } else if ($helpTitleElem.length) {
        $helpTitleElem.attr('id', 'modal-help-title'); //For Help Modals
      }

      $self.find('.bootbox-body').attr('id', 'modal-desc');
      $self.find('.bootbox-close-button').removeAttr('aria-hidden').attr('aria-label', 'Close');

      $self.attr('role', role)
        .attr('aria-labelledby', $('#modal-help-title').text())
        .attr('aria-describedby', 'modal-desc'); //$('#modal-desc').find('p').first().text()

      //focus on first focusable element inside modal if available else focus on modal element
      if (!Mgp.Accessibility.SetFocus($self.children(':first'))) {
        $self.trigger('focus');
      }

      Mgp.SetDataAttributeForE2ETesting(true);
      Mgp.Accessibility.PreventEnterInputSubmit();

      //If in the Single Page Convo legacy iframe and a modal is popped up scroll to the top of the iframe to see the modal
      if (Mgp.IsSinglePageConversationLegacyIframe()) {
        let windowDistanceToTop = window.parent.pageYOffset;
        let frameDistanceToTop = window.parent.document.getElementById('mg-conversation-legacy-step-iframe').offsetTop;

        if (windowDistanceToTop > frameDistanceToTop) {
          window.parent.scrollTo({ top: frameDistanceToTop, behavior: 'smooth' });
        }
      }
    });

    $(document).on('keydown', '.bootbox', function (event) { // For Modal Accessibility Trap tabkey within modal
      Mgp.Accessibility.TrapTabKey($(this), event); // call trap function
    });

    //Prevent dropdown from being closed when we click on an accordion link
    $('.dropdown-accordion .panel-collapse').collapse({ toggle: false });

    $('.dropdown-accordion').on('click', function (event) {
      if ($(event.target).closest('.dropdown-toggle').length) {
        $(this).data('closable', true);
      } else {
        $(this).data('closable', false);
      }
    });

    $('.dropdown-accordion').on('hide.bs.dropdown', function (event) {
      var hide = $(this).data('closable');
      $(this).data('closable', true);
      return hide;
    });

    $('.dropdown-accordion').on('click', 'a[data-toggle="collapse"]', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var $parent = $($(this).data('parent')).find('.panel-collapse.in');
      var parent_href = '#' + $parent.attr('id');
      var href = $(this).attr('href');
      $parent.collapse('toggle');
      if (parent_href !== href) {
        $(href).collapse('toggle');
      }
    });
    //Dropdown Accordion End

    $('.zoomer-mobile-menu-btn').on('click', function () {
      var $zoomerMenu = $('#mgp-nav ul.progressbar');
      $zoomerMenu.toggleClass('is-active');
    });

    $('.close-window').on('click', function (event) {
      event.preventDefault();
      window.close();
    });


    $('a.zoomer-subpage-navigate-link')
      .on('click', function (event) {
        event.preventDefault();
        var $form = $('form');
        var nextUrl = $('<input>')
          .attr('type', 'hidden')
          .attr('name', 'nextUrl')
          .val($(this).attr('href'));

        var data_submit = $(this).data('submit');

        if (data_submit) {
          var submit = $('<input>')
                      .attr('type', data_submit)
                      .attr('name', data_submit);

          $form.append(submit);
        }

        $form.append(nextUrl);

        if (!$form.valid())
          return false;

        //Used by EndExpenseSummary partial included on the goal slider entery method
        if (Mgp.IsSinglePageConversationLegacyIframe()) {
          $form.prop('target', '_parent');
        }

        $form.trigger('submit');
      });

    //For Web Accessibility
    Mgp.Accessibility.SetPageTitle();

    /*Start Anything that needs to be tracked by Google Analytics*/
    $('.track-video').on('click', function () {
      Mgp.Analytics.GoogleTracking($(this), 'Training Videos', 'MG_PlayTrainingVideos');
    });
    $('.track-userguide').on('click', function () {
      Mgp.Analytics.GoogleTracking($(this), 'User Guides Links', 'MG_ClickUserGuidesLinks');
    });
    $('.track-knowledge-base-button').on('click', function () {
      Mgp.Analytics.GoogleTracking($(this), 'Knowledge Base Button', 'MG_ClickKnowledgeBaseButton');
    });
    //The next two are for JIRA MGFUTURE-8120
    $('.track-get-quotes').on('click', function () {
      Mgp.Analytics.GoogleTracking($(this), 'Get Quotes Button', 'MG_ClickCovrButton');
    });
    $('.track-solve-for-term-policies').on('click', function () {
      Mgp.Analytics.GoogleTracking($(this), 'Solve for Term Policies Button', 'MG_ClickCovrButton');
    });
    /*End Anything that needs to be tracked by Google Analytics*/
    Mgp.Accessibility.CloseDropdownOnFocusOut();

    //Axe Web Accessibility is flagging dropdown content containes for having aria-expanded attribute
    //Remove this attribute
    Mgp.Accessibility.RemoveAriaExpandedOnDropdownContentContainer();
  });

  return {
    ScrollToTopMinPx: 600,
    LabVideoName: '',
    LabVideoConfigOptions: null,
    PopupWindowHandle: null,

    SetAllowMultipleOpenModals: function (allowOpen) {
      modalOpen = allowOpen ? false : true;
    },

    // Scroll to Top Plugin Used Globally
    // --Check to see if the window is top if not then display button
    ScrollToTop: function () {
      var $scrollToTop = $('.scrollToTop');

      if ($(window).scrollTop() > Mgp.ScrollToTopMinPx) {
        $scrollToTop.fadeIn();
      } else {
        $scrollToTop.fadeOut();
      }
    },

    SignOff: function () {
      $(document).on('click', '.logout-link', function (e) {
        if (Mgp.StorageAvailable('localStorage')) {
          //set and change value to fire storage event listener
          localStorage.setItem('mgpSessionLoggedOut', 'false');
          localStorage.setItem('mgpSessionLoggedOut', 'true');
        }
        if (Mgp.StorageAvailable('sessionStorage')) {
          sessionStorage.removeItem('mgpAdminLaunchedSession');
        }
        if (typeof Settings.SignOffUrl !== 'undefined') {
          //Only preventDefault if has Settings.SignOffUrl (exists when AppContext.Session.CurrentUser.Exists) 
          //otherwise allow default event (needed for Inst User Settings)
          e.preventDefault();

          Mgp.ClearSpaSessionStorage();
          sessionStorage.setItem('mgpActiveTimerInitialized', 'false');
          window.location.href = Settings.SignOffUrl;
        }
      });

      window.addEventListener('storage', function (e) {
        if (e.key === 'mgpSessionLoggedOut') {
          if (e.newValue === true || e.newValue === 'true') {
            if (typeof Settings.SignOffUrl !== 'undefined') {
              Mgp.ClearSpaSessionStorage();
              sessionStorage.setItem('mgpActiveTimerInitialized', 'false');
              window.location.href = Settings.SignOffUrl;
            }
          }
        }
      });
    },

    SetDataAttributeForE2ETesting: function (isModal) {
      var elemSet = 'input:not([type="hidden"]), select, button, a';

      if (isModal && document.getElementsByClassName('modal')[0]) {
        var elemList = document.getElementsByClassName('modal')[0].querySelectorAll(elemSet)
      } else {
        var elemList = document.querySelectorAll(elemSet);
      }

      var elemArray = [...elemList]; //converts NodeList to Array

      elemArray.forEach(elem => {
        let origElemId = elem.id;

        if (origElemId.length === 0) {
          origElemId = elem.name;
        }

        if (origElemId.length > 0) {
          let formattedElemId = origElemId.replaceAll('_', '').replaceAll('-', '').replaceAll('.', '');

          formattedElemId = formattedElemId.charAt(0).toUpperCase() + formattedElemId.slice(1);

          elem.setAttribute("data-testid", "e2e" + formattedElemId);
        }
      });
    },

    IsZoomerPopUp: function () {
      try {
        var location = window.opener.location.href.toLowerCase();

        return window.opener ? (location.indexOf('financial-zoomer') > -1 ||
          location.indexOf('wealthstudios') > -1 ||
          location.indexOf('snapshot/overview?isembedded=true') > -1) : false;  //MGFUTURE-8016 - Snapshot inside the Financial Plan needs this hack or dark theme is never set
      } catch (error) {
        return false;
      }
    },

    SetupTheme: function () {
      var isZoomerPopup = Mgp.IsZoomerPopUp();

      if (Settings.HasMGDarkThemeOption || isZoomerPopup) {
        if (Settings.UseMGDarkTheme) {
          //Even though moved UseMGDarkTheme to the back-end we still need SetupThemeDisplay for MStar ticker lookup, Support Center, Finish -> Share step popups
          //until dark theme is global and not just in the Financial Goal Plan
          if (isZoomerPopup) { 
            Mgp.SetupThemeDisplay(true);
          }
        } 
      }
    },

    //Only used for MStar ticker lookup, Support Center, Finish -> Share step popups
    //Will go away once dark theme is global and not just in the Financial Goal Plan
    SetupThemeDisplay: function (isDarkTheme) {
      var themeLink = document.getElementById('mg-css-theme');

      if (isDarkTheme) {
        themeLink.setAttribute('href', themeLink.getAttribute('data-css-path-dark-theme'));
      } else {
        themeLink.setAttribute('href', themeLink.getAttribute('data-css-path-light-theme'));
      }
    },

    PageScroll: function () {
      $('a.page-scroll[href*="#"]:not([href="#"])')
        .off('click')
        .on('click', function () {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
            && location.hostname === this.hostname) {
          var target = $(this.hash);

          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            var $page = $('html,body'),
                cancel = function () { $page.stop(); };

            $page.animate({ scrollTop: target.offset().top - 50 }, 1000, function () {
              $page.off(cancelAnimationEvents, this, cancel);
            }).on(cancelAnimationEvents, cancel);

            return false;
          }
        }
      });
    },

    //Prevent multiple submission of forms
    PreventDoubleClick: function ($elem, event) {
      var timeoutMS = $elem.data('onclick-disable-interval') ? $elem.data('onclick-disable-interval') : 5000;
      var onClickDisableBtn = $elem.data('onclick-disable-btn') ? $elem.data('onclick-disable-btn') : false; //Implemented for JIRA MGP-817 (legacy code form submits)

      if (!$elem.data('isClicked')) {
        var item = $elem;

        if (onClickDisableBtn) {
          if ($elem.hasClass('btn')) {
            $elem.prop('disabled', true); //for buttons
          } else {
            $elem.addClass('prevent-click-before-load'); //for anchors
          }
        }
        item.data('isClicked', true);

        setTimeout(function () {
          if (onClickDisableBtn) {
            if ($elem.hasClass('btn')) {
              $elem.prop('disabled', false); //for buttons
            } else {
              $elem.removeClass('prevent-click-before-load'); //for anchors
            }
          }
          item.removeData('isClicked');
        }, timeoutMS);
      }
      else {
        if (onClickDisableBtn) {
          if ($elem.hasClass('btn')) {
            $elem.prop('disabled', true); //for buttons
          } else {
            $elem.addClass('prevent-click-before-load'); //for anchors
          }
        }
        event.preventDefault();
        return false;
      }
    },

    MaskInputs: function () {
      // Form Field Masking
      // Added clearIncomplete: true for all dates, removeMaskOnSubmit: true just for
      //yyyy (adding for others breaks validation b/c it removes the "/" character) - Case 8334
      if (!Mgp.Browser.IsAndroid()) {
        $('.dateFormatMMDDYYYY').inputmask({
          mask: '99/99/9999', placeholder: 'mm/dd/yyyy', clearIncomplete: true  //removeMaskOnSubmit: true
        });
        $('.dateFormatMMYYYY').inputmask({
          mask: '99/9999', placeholder: 'mm/yyyy', clearIncomplete: true //removeMaskOnSubmit: true
        });
        $('.dateFormatYYYY').inputmask({
          mask: '9999', placeholder: 'yyyy', clearIncomplete: true, removeMaskOnSubmit: true, rightAlign: false
        });
        $('.phoneNumber').inputmask({
          mask: '999-999-9999[x9{1,5}]', greedy: false
        });
        $('.phoneNumberNoExt').inputmask({
          mask: '999-999-9999', greedy: false
        });
      }
    },

    PleaseWait: function (hideClose, msg) {
      var closeButton = hideClose ? false : true;

      if (typeof msg === 'undefined') {
        var msg = 'Please wait while we process your request ...';
      }

      var msgHtml = '<br/><div style="display:flex; align-items:flex-start; flex-wrap: nowrap;"><div class="h4">';
        msgHtml += '<i class="fa spinner fa-spin fa-lg" aria-hidden="true"></i>&nbsp;</div><div class="h4">' + msg;
        msgHtml += '</div></div><br/>';

      Mgp.SetAllowMultipleOpenModals(true);

      return bootbox.dialog({
        closeButton: closeButton,
        message: msgHtml,
        className: 'please-wait-modal'
      });
    },

    // More/Less and Show/Hide Toggles
    Toggle: function (section) {
      var $toggleSectionElem = $('#toggle-' + section);

      if ($('.' + section).length) {  //Only show toggle link if there is content available - Case 7258
        $toggleSectionElem.on('click', function (event) {
          var $self = $(this),
              selfText = $self.text(),
              selfDiv = $self.find('div');

          $('.' + section).toggle().is(':visible');

          if (selfDiv.length) {
            selfDiv.toggleClass('contract').toggleClass('expand');
          }
          if (selfText === 'Show more' || selfText === 'Show less') {
            if (selfText === 'Show more') {
              $self.text('Show less');
              $self.attr('aria-expanded', 'true');
            }
            else {
              $self.text('Show more');
              $self.attr('aria-expanded', 'false');
            }
          }
          else if ($self.text() === 'Show' || $self.text() === 'Hide') {
            if (selfText === 'Show') {
              $self.text('Hide');
              $self.attr('aria-expanded', 'true');
            } else {
              $self.text('Show');
              $self.attr('aria-expanded', 'false');
            }
          }

          //for toggle arrows
          if ($self.hasClass('toggle') && $self.hasClass('collapsed')) {
            $self.removeClass('collapsed');
            $self.attr('aria-expanded', 'true');
          }
          else if ($self.hasClass('toggle') && !$self.hasClass('collapsed')) {
            $self.addClass('collapsed');
            $self.attr('aria-expanded', 'false');
          }

          event.preventDefault();  //prevent toggling from taking you back to top of page
        });
      }
      else {
        $('#toggle-' + section).hide();
      }
    },

    ToggleAllDetails: function ($containerElem) {

      if ($containerElem.length > 0) {
        $('.toggle-details').on('click', function () {
          var $self = $(this);

          if ($containerElem.attr('id') === $self.data('associated-container')) {
            var $collapseElems = $containerElem.find('.collapse'),
                text = $self.text(),
                textLowerCase = text.toLowerCase();

            if (textLowerCase.indexOf('show') > -1) {
              $self.text(text.replace('Show', 'Hide'));
              $collapseElems.collapse('show');
              $self.attr('aria-expanded', 'true');
            }
            else {
              $self.text(text.replace('Hide', 'Show'));
              $collapseElems.collapse('hide');
              $self.attr('aria-expanded', 'false');
            }
            return false; //Need return false to prevent jquery Syntax error, unrecognized expression: #
          }
        });
      }
    },

    DisableInputs: function () {
      //add aria-readonly to disabled inputs
      $('input[readonly], textarea[readonly], select[readonly]').attr('aria-readonly', 'true');

      if (Settings.ViewOnly) {
        $('input, select, textarea, .yes-no-toggle')
          .not('.always, .alwaysEnable, input[type="hidden"], input[type="button"], input[type="submit"]')
          .each(function () { PIE.readonly.disable(this); });
      }
      else {
        $('input.disable, select.disable, textarea.disable').each(function () { PIE.readonly.disable(this); });
      }
    },

    WarningInput: function ($elem, showWarning, msg) {
      var $inputGroup = $elem.parents('.input-group:first');

      if (showWarning) {
        if (!$inputGroup.hasClass('has-warning')) {
          $inputGroup.addClass('has-warning');
          $elem.parents('.input-group:first')
              .append('<span class="input-group-addon has-warning-add-on"><button type="button" class="btn-link" style="padding:0;border:none;" title="' +
                      msg + '" data-toggle="tooltip"><i class="fa warning-tooltip"></i></button></span>');
        }
      }
      else {
        $inputGroup.removeClass('has-warning');
        $inputGroup.find('.has-warning-add-on').remove();
      }
    },

    RenderModal: function () {
      $(document).on('click', '.help-modal, .small-modal, .medium-modal, .large-modal', function (event) {
        var $dialog,
            $modalLink = $(this),
            modalTitle = $modalLink.data('modal-title') || null,
            modalClasses = $modalLink.attr('class').split(' '),
						modalClass = '',
            modalSize = '',
            modalRight = false,
            i = 0;

        for (i = 0; i < modalClasses.length; i++) {
          if (modalClasses[i].indexOf('-modal') > -1) {
            modalClass = modalClasses[i];
          }
        }

        if (modalClass === 'small-modal') {
          modalSize = 'small';
        }
        else if (modalClass === 'large-modal' || modalClass === 'help-modal') {
          modalSize = 'large';
          modalRight = true;
        }
        else {
          modalSize = '';
        }

        $.ajax({
          type: 'GET',
          url: $(this).attr('href'),
          beforeSend: function () {
            $dialog = bootbox.dialog({
              title: modalTitle,
              size: modalSize,
              className: modalRight ? 'modal-right' : '',
              onEscape: true,
              message: '<br/><h4><i class="fa spinner fa-spin fa-lg" aria-hidden="true"></i>&nbsp;' +
                       'Please wait while we process your request ...</h4><br/>',
              buttons: {
                success: {
                  label: 'OK',
                  className: 'btn-done'
                }
              }
            });

            Mgp.Accessibility.ModalAiraHideOutsideContent($dialog);

            //Prevent help icons inside panel-heading from triggering panel toggle, i.e. (Case 8229)
            event.stopPropagation();
          },
          success: function (data) {
            $dialog.find('.bootbox-body').html(data);

            $dialog.find('.btn-cancel, .btn-back, .btn-close').on('click', function (event) {
              $dialog.modal('hide');
              event.preventDefault();
              return false;
            });
          }
        });

       event.preventDefault();
      });
    },

    Toolbar: {
      //Notes: function ($self) {
      //  $.ajax({
      //    type: 'GET',
      //    url: $self.attr('href'),
      //    dataType: 'json',
      //    cache: false,
      //    success: function (data) {
      //      var enforceFocus = $.fn.modal.Constructor.prototype.enforceFocus;
      //      $.fn.modal.Constructor.prototype.enforceFocus = function () { };

      //      var $box = bootbox.dialog({
      //        message: data.Html,
      //        onEscape: true,
      //        className: 'notes-modal',
      //        size: 'large'
      //      });

      //      Mgp.Accessibility.ModalAiraHideOutsideContent($box);

      //      $box.on('shown.bs.modal', function () {
      //        if (typeof (HouseholdNotes) !== 'undefined') {
      //          HouseholdNotes.Init();  //household notes
      //        } else {
      //          notes.init(); //plan notes
      //        }
      //      });
      //      $box.on('hidden.bs.modal', function () {
      //        $.fn.modal.Constructor.prototype.enforceFocus = enforceFocus;
      //      });
      //    }
      //  });

      //  return false;
      //},

      //Only ever show Bootstrap hamburger menu when there are menu items
      NavBarToggleDisplay: function () {
        var $navbar = $('#navbar');
        var $navbarLogout = $navbar.find('.logout');

        if (!$navbar.find('.toolbar-dropdown-container').find('li').length &&
          !$navbar.find('.support').length &&
          (!$navbarLogout.length || $navbarLogout.is(':empty'))) {
          var $mgpToolbar = $('#mgp-toolbar');

          //Outside the places that use toolbarV2 (financial plan, Wealth Studios, and SnapshotV2) still has breadcrumbs opened by hamburger menu in xs viewport so don't hide the hamburger menu in that case
          if ($mgpToolbar.hasClass('toolbarV2') || $mgpToolbar.hasClass('no-breadcrumbs')) {
            $('.navbar-toggle').addClass('hidden').removeClass('visible-xs-block');
          }
        }
      }
    },

    ToolTip: {
      CreateCloseIcon: function () {
        var $tooltipTemplate = $('.tooltip-inner');

        if (!$tooltipTemplate.find('.tooltip-close').length) {
          $tooltipTemplate
            .prepend('<a class="close tooltip-close" data-dismiss="tooltip">&times;</a>');
        }
      }
    },

    GoalImportance: {
      GROUP: {
        Need: 'Need',
        Want: 'Want',
        Wish: 'Wish'
      },

      BY_GROUP: {
        Need: 10,
        Want: 7,
        Wish: 3
      },

      GetGroup: function (importance) {
        if (!importance || importance <= 3) {
          return Mgp.GoalImportance.GROUP.Wish;
        }
        else if (importance <= 7) {
          return Mgp.GoalImportance.GROUP.Want;
        }
        else {
          return Mgp.GoalImportance.GROUP.Need;
        }
      }
    },

    CreateNamespacedFunction: function (functionName) {
      var parts = functionName.split('.');
      for (var i = 0, len = parts.length, obj = window; i < len; ++i) {
        obj = obj[parts[i]];
      }
      return obj;
    },

    Format: {
      Numeric: function (field) {
        var val;

        if (field.length) {
          if (field.is('[value]')) {
            val = field.val().replace(/[^\d\.]/g, '');
          }
          else {
            val = field.text().replace(/[^\d\.]/g, '');
          }
          if (val !== '') {
            return parseFloat(val);
          }
        }
        return 0;
      },
      //http://stackoverflow.com/questions/10599933/convert-long-number-into-abbreviated-string-in-javascript-with-a-special-shortn
      AbbreviateNumber: function(num, fixed) {
        if (num === null) {
          return null;
        } // terminate early
        if (num === 0) {
          return '0';
        } // terminate early

        fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show

        var b = (num).toPrecision(2).split("e"), // get power
            k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
            c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3) ).toFixed(1 + fixed), // divide by power
            d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
            e = d + ['', 'k', 'm', 'b', 't'][k]; // append power

        return e;
      }
    },

    LocationUpdate: function () {
      //window.location.reload(true); <-- Was logging users out of iframe in IE11 - USAA
      window.location.href = window.location.href;
    },

    Browser: {
      IsAndroid: function () {
        var userAgent = navigator.userAgent.toLowerCase();
        //Since many websites do use this kind of OS detection, but ignore Windows Phone,
        //Microsoft decided to put "Android" and "iPhone" into the userAgent String as well.
        if (!/iemobile/i.test(userAgent)) {
          if (/android/i.test(userAgent)) {
            return true;
          }
        }
        return false;
      }
    },

    Viewport: {
      Size: {
        Xs: 'xs',
        Sm: 'sm',
        Md: 'md',
        Lg: 'lg'
      },

      DetectSize: function () {
        var breakpoints = {
          'xs': '<div id="device-xs" class="visible-xs visible-xs-block"></div>',
          'sm': '<div id="device-sm" class="visible-sm visible-sm-block"></div>',
          'md': '<div id="device-md" class="visible-md visible-md-block"></div>',
          'lg': '<div id="device-lg" class="visible-lg visible-lg-block"></div>'
        },
        breakpointSize = '',
  	    detectHtml = breakpoints.xs + breakpoints.sm + breakpoints.md + breakpoints.lg;

        if (!$('#device-xs').length) {
          $('body').append(detectHtml);
        }

        $.each(breakpoints, function (key) {
          if ($('#device-' + key).is(':visible')) {
            breakpointSize = key;
          }
        });

        return breakpointSize;
      },

      IsEqualOrGreaterThan: function (size) {
        var viewPorts = $.map(Mgp.Viewport.Size, function (item) { return item; }),
  	        allowedSizeIndex = $.inArray(size, viewPorts),
            currentSize = Mgp.Viewport.DetectSize(),
  	        currentSizeIndex = $.inArray(currentSize, viewPorts);

        if (allowedSizeIndex !== -1) {
          return currentSizeIndex >= allowedSizeIndex;
        }
        return true;
      }
    },

    Navigate: {
      Loading: function ($elem) {
        if (!$('.has-error').length) {
          if ($elem.hasClass('use-loading-indicator')) {
            if (!$elem.children(':first').hasClass('nav-waiting')) {
              $elem.prepend('<i class="fa spinner fa-spin nav-waiting" aria-label="Loading"' +
              'aria-live="assertive" aria-busy="true" role="alert"></i> ');
            }
          }
        }
      },

      LoadingStop: function ($disabledElem) {
        var $navWaiting = $('.nav-waiting');

        if($navWaiting.length > 0) {
          $navWaiting.remove();
          if (typeof $disabledElem !== 'undefined' && $disabledElem.length) {
            $disabledElem.removeClass('prevent-click-before-load');
          }
        }
      },

      CancelBtnAction: function ($self, $form, isPopup, returnUrl) {
        if (isPopup) {
          window.close();
        }
        else {
          if (returnUrl) {
            window.location.href = returnUrl;
          }
          else {
            //Investment Assets Cancel uses this
            if ($self.is('[type=submit]')) {
              $form.trigger('submit');
            }
          }
        }
      },

      GetLabVideoConfigOptions: function () {
        var noLabSelected = 0,
            selectedLabId = Settings.SelectedLabId;

        if ((typeof (Settings.SelectedLabId) !== 'undefined')) {
          if (selectedLabId !== noLabSelected) {
            var MAX_ROUTE_SECTIONS = 3, //area/controller/action  //Used to handle Goals Add/Edit, Investment Assets Add/Edit, etc. has account guid after these 3
                ACTION_INDEX = 2,
                routeSections = 0,
                urlPathName = window.location.pathname.toLowerCase(),
                urlArray = urlPathName.split('/'),
                url = '',
                labSubSectionTypeId = '',
                labVideoBaseInstUrl = '',
                labVideoInstExt = Settings.LabVideoExt,
                labVideoInstExtFormatted = labVideoInstExt.toLowerCase() + '/', //make folders for institution specific version of videos
                planId = Settings.PlanId;

            urlArray.splice(0, 2); //remove referral

            routeSections = urlArray.length > MAX_ROUTE_SECTIONS ? MAX_ROUTE_SECTIONS : urlArray.length;

            for (var i = 0; i < routeSections; i++) {
              if (routeSections === MAX_ROUTE_SECTIONS && i === ACTION_INDEX) {
                //Used for as a hack for Play Zone that has 'worksheet' and 'worksheet-step' actions but route to the same page
                //Removing the '-step' if at the end of the action name eliminates the need for redundant video files and we might have more of these '-step' in the future
                url += urlArray[i].replace(/\-step$/, '');
              } else {
                url += urlArray[i];
              }

              if (i < routeSections - 1) {
                url += '_';
              }
            }

            //used for some Resource sub types that need a specific video for each type
            //setup for Retirement Income, Other Assets, Investment Assets, Other Goals, and Household Loss Tolerance (need for single) as of 11/23/16
            if (typeof (Settings.LabSubSectionTypeId) !== 'undefined') {
              labSubSectionTypeId = $.trim(Settings.LabSubSectionTypeId).toLowerCase();

              if (labSubSectionTypeId.length > 0) {
                url += '_' + labSubSectionTypeId;
              }
            }

            Mgp.LabVideoName = url.replace(/-/g, '_') + '_' + selectedLabId;

            //if (urlArray[0] === 'financial-zoomer')     //For Ryan remove after videos complete
            //  console.log(Mgp.LabVideoName + '.mp4');   //For Ryan remove after videos complete

            labVideoBaseInstUrl = Settings.LabCdn + '/videos/labs/' + labVideoInstExtFormatted;

            Mgp.LabVideoConfigOptions = {
              key: planId + '_' + Mgp.LabVideoName,
              planId: planId,
              selectedLabId: selectedLabId,
              baseInstUrl: labVideoBaseInstUrl,
              instExt: labVideoInstExt,
              videoName: Mgp.LabVideoName,
              isLabMessage: true,
              isOnNavigate: false
            };

            //postMessage the MyMG video url to jwplayer on the labs frame page
            window.parent.postMessage(JSON.stringify(Mgp.LabVideoConfigOptions), '*');

            //Update MyMG video time position whenever Mgp page nav
            window.onbeforeunload = function () {
              Mgp.LabVideoConfigOptions = {
                key: planId + '_' + Mgp.LabVideoName,
                isLabMessage: true,
                isOnNavigate: true
              };
              window.parent.postMessage(JSON.stringify(Mgp.LabVideoConfigOptions), '*');

              return undefined; //must return undefined otherwise browser built in message will show
            };
          }
        }
      }
    },
    
    Accessibility: {
      ModalAiraHideOutsideContent: function ($dialog) {
        $dialog.on('shown.bs.modal', function () {
          $(this).siblings().not('script, style, link').attr('aria-hidden', true);
          $(this).attr('aria-modal', true);
        });
        $dialog.on('hide.bs.modal', function () {
          $(this).siblings().not('script, style, link').removeAttr('aria-hidden');
        });
      },

      //set focus to first focusable item inside container element
      SetFocus: function ($elem) {
        var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled])' +
          'textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
          $allElemsInModal = $elem.find('*');

        var $elemToFocus = $allElemsInModal.filter(focusableElementsString).filter(':visible').first();

        //Only scroll to elem if it's in the viewport
        if ($elemToFocus[0]) {
          if (window.innerHeight > $elemToFocus[0].getBoundingClientRect().top) {
            return $elemToFocus.trigger('focus');
          }
        }
      },
      // trap tab focus within container element
      TrapTabKey: function ($elem, evt) {
        var focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]", obj, focusableItems, focusedItem, numberOfFocusableItems, focusedItemIndex;
        // if tab or shift-tab pressed
        if (evt.which == 9) {

          // get all children elements in given object
          obj = $elem.find('*');

          // get focusable items
          focusableItems = obj.filter(focusableElementsString).filter(':visible');

          // get currently focused item
          focusedItem = $(':focus');

          // get the number of focusable items
          numberOfFocusableItems = focusableItems.length;

          // get the index of the currently focused item
          focusedItemIndex = focusableItems.index(focusedItem);

          if (evt.shiftKey) {
            //back tab
            // if focused on first item and user preses back-tab, go to the last focusable item
            if (focusedItemIndex == 0) {
               focusableItems.get(numberOfFocusableItems - 1).focus();
              evt.preventDefault();
            }

          } else {
            //forward tab
            // if focused on the last item and user preses tab, go to the first focusable item
            if (focusedItemIndex == numberOfFocusableItems - 1) {
               focusableItems.get(0).focus();
              evt.preventDefault();
            }
          }
        }
      },

      YesNoToggleByArrowKeys: function (event) {
        var keyCode,
            $yesNoToggleElem = $(event.target),
            LEFT_ARROW_KEY = 37,
            UP_ARROW_KEY = 38,
            RIGHT_ARROW_KEY = 39,
            DOWN_ARROW_KEY = 40;

        keyCode = (event.which ? event.which : event.keyCode);

        if (keyCode === LEFT_ARROW_KEY || keyCode === UP_ARROW_KEY ||
          keyCode === RIGHT_ARROW_KEY || keyCode === DOWN_ARROW_KEY) {
          if (!$yesNoToggleElem.hasClass('disabled')) {
            $yesNoToggleElem.trigger('click');
          }
        }
      },

      SetPageTitle: function () {
        var defaultTitle = document.title,
          title = defaultTitle,
          $titleDescElem = null,
          headerHidden = ':hidden, .sr-only',
          $pageHeader = $('.pageheader').first(),
          $h1Header = $('h1').not(headerHidden).first(),
          $h2Header = $('h2').not(headerHidden).first(),
          $h3Header = $('h3').not(headerHidden).first();


        if ($pageHeader.length) {
          $titleDescElem = $pageHeader;
        }
        else if ($h1Header.length) {
          $titleDescElem = $h1Header;
        }
        else if ($h2Header.length) {
          $titleDescElem = $h2Header;
        }
        else if ($h3Header.length) {
          $titleDescElem = $h3Header;
        }

        if ($titleDescElem) {
          title = $titleDescElem.clone().children().remove().end().text() + ' | ' + defaultTitle;
        }
        else {
          title = defaultTitle;
        }

        //Jira MGFUTURE-9987 - Reports doesn't have a step header bar so set document title from legacy
        if (Mgp.IsSinglePageConversationLegacyIframe() && Settings.SetDocumentTitle) {  
          window.parent.document.title = title;
        } else {
          window.document.title = title;
        }
      },

      //Added this for web accessibility this allows Expectations and Concerns user icons to be toggled by
      //keyboard Enter press button without submitting the form
      PreventEnterKeySubmit: function () {
        $('form').on('keypress', function (e) {
          var $FocusedElem = $(':focus');

          if ($FocusedElem.attr('type') !== 'submit') {
            var code = (e.keyCode ? e.keyCode : e.which);
            if (code === 13)
              return false;
          }
        });
      },

      //Prevent form submit on enter key press - i.e. Max Savings Amount, modal inputs, etc. - Jira MGP-3686
      PreventEnterInputSubmit: function () {
        $('form').on('keypress', 'input:not([type="submit"])', function (e) {
          var code = (e.keyCode ? e.keyCode : e.which);

          if (code === 13) {
            e.preventDefault();
            return false;
          }
        });
      },

      //State Farm ADA request
      CloseDropdownOnFocusOut: function () {
        //https://stackoverflow.com/a/31732310 
        var isBrowserOnAppleDevice = (navigator.vendor && navigator.vendor.indexOf('Apple') > -1) ||
          (navigator.userAgent &&
          (navigator.userAgent.indexOf('CriOS') > -1 ||
           navigator.userAgent.indexOf('FxiOS') > -1));

        //Only apply to Zoomer .progressbar and .navbar-nav for now - also this doesn't work on Apple devices regardless of browser, mobile iOS, or Macbook
        //too many inconsistancies in code - Resource dropdowns, Playzone dropdowns with scrollbars close if you click on the scrollbar so only implemented for progress bar and top nav bar
        if (!isBrowserOnAppleDevice) {
          var dropdownMenuContainerElements = $('.progressbar, .navbar-nav').find('.dropdown-menu').parent(); //$('.dropdown-menu').parent(); //get the container of the dropdown menu

          for (var i = 0; i < dropdownMenuContainerElements.length; i++) {
            dropdownMenuContainerElements[i].addEventListener('focusout', function (event) {
              if (!this.contains(event.relatedTarget)) {
                var $self = $(this);
                var $dropdownMenu = $self.find('.dropdown-menu');

                $self.removeClass('open');
                $dropdownMenu.attr('aria-expanded', 'false');
              }
            });
          }
        }
      },

      RemoveAriaExpandedOnDropdownContentContainer: function () {
        $(document).on('show.bs.collapse', function (e) {
          setTimeout(function () {
            $('#' + e.target.id).removeAttr('aria-expanded');
          }, 0);
        })
        $(document).on('hide.bs.collapse', function (e) {
          setTimeout(function () {
            $('#' + e.target.id).removeAttr('aria-expanded');
          }, 0);
        })
      }
    },

    //Sticky Table Header
    Tables: {
      FixedHeader: function () {
        var $stickyHeadTable = $('.stickyHead-table');

        if ($stickyHeadTable.length && $stickyHeadTable.is(':visible')) {
          $stickyHeadTable.floatThead({
            responsiveContainer: function ($stickyHeadTable) {
              return $stickyHeadTable.closest('.table-responsive');
            },
            getSizingRow: function ($stickyHeadTable) { //http://mkoryak.github.io/floatThead/examples/row-groups/
              return $stickyHeadTable.find('tbody tr:not(.grouping):visible:first>*');
            }
          });

          //In IE11 first row in table (Results - Combined Details) is partially hidden without a reflow
          if (window.browserIsIE()) {
            $stickyHeadTable.trigger('reflow'); 
          }

          //Added for JIRA MGP-5841 so if user maximinizes or resizes popup window width floatThead knows to reflow the table
          //https://github.com/mkoryak/floatThead/issues/268
          $(window).one('scroll', function () {
            $stickyHeadTable.trigger('reflow');
          });

          $(window).on('resize', function () {
            setTimeout(function () {
              $stickyHeadTable.trigger('reflow');
            }, 250);
          });
        }

      }
    },

    //Sticky Footer
    SetFooter: function () {
      $('body').css('margin-bottom', $('#mgp-footer').height());
    },

    Analytics: {
      GoogleTracking: function (elem, trackCategory, trackAction) {
        if (typeof gtag !== 'undefined') {
          if (typeof Settings.ExcludeMGAnalytics !== 'undefined' && Settings.ExcludeMGAnalytics === 'false') {
            var trackLabel = elem.val() !== '' ? elem.val() : elem.text();

            if ($.trim(trackLabel) === '') {
              trackLabel = elem.find('img').attr('alt');
            }

            gtag('event', trackAction, {
              'event_category': trackCategory,
              'event_label': trackLabel
            });
          }
        }
      }
    },

    Colors: {
      HexToRgb: function(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
          return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      }
    },

    //https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
    //Feature detect if browser storage is available
    StorageAvailable: function (type) {
      try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      }
      catch (e) {
        return false;
      }
    },

    ClearSpaSessionStorage: function () {
      try {
        store.session.namespace('moneyguide.financial-zoomer.' + Settings.HouseholdId).clear();
        store.session.namespace('moneyguide.snapshot.' + Settings.HouseholdId).clear();
        store.session.namespace('moneyguide.wealthstudios.' + Settings.HouseholdId).clear();
      }
      catch (e) {
        return false;
      }
    },

    //Only used by Single Page Conversation
    IsSinglePageConversationLegacyIframe: function () {
      //Do this check in a try catch because if the window parent is cross-domain this will throw an error
      try {
        if (window.parent.document.getElementById('mg-conversation-legacy-step-iframe')) {
          return true;
        }
      } catch (e) {
        return false;
      }
    },

    TogglePassword: {
      Init: function () {
        let togglePasswordBtns = document.querySelectorAll('.password-toggle-icon');
        
        togglePasswordBtns.forEach(togglePasswordBtn => {
          togglePasswordBtn.addEventListener('click', function (event) {
            Mgp.TogglePassword.SetVisibility(event.currentTarget);
          });
        });
      },

      SetVisibility: function (togglePasswordBtn) {
        let togglePasswordIcon = togglePasswordBtn.getElementsByTagName('i')[0];
        let previousSiblings = Mgp.TogglePassword.GetAllPreviousSiblings(togglePasswordBtn);
        let passwordField;

        for (let i = 0; i < previousSiblings.length; i++) {
          if (previousSiblings[i].name?.toLowerCase().indexOf('password') >= 0) {
            passwordField = previousSiblings[i];
            break;
          }
        }

        if (passwordField) {
          if (passwordField.type === 'password') {
            passwordField.type = 'text';
            togglePasswordBtn.setAttribute('aria-label', 'Hide Password');
            togglePasswordIcon.title = 'Hide Password';
            togglePasswordIcon.classList.remove('fa-eye');
            togglePasswordIcon.classList.add('fa-eye-slash');
          } else {
            passwordField.type = 'password';
            togglePasswordBtn.setAttribute('aria-label', 'Show Password');
            togglePasswordIcon.title = 'Show Password';
            togglePasswordIcon.classList.remove('fa-eye-slash');
            togglePasswordIcon.classList.add('fa-eye');
          }
        }
      },

      GetAllPreviousSiblings: function (element) {
        const siblings = [];
        let current = element.previousElementSibling;

        while (current) {
          siblings.push(current);
          current = current.previousElementSibling;
        }
        return siblings;
      }
    }

  };

}(jQuery));